import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useRef, useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { search, close } from '@equinor/eds-icons';
import { Button } from '../Button/index.js';
import { Icon } from '../Icon/index.js';
import { mergeRefs, setReactInputValue } from '@equinor/eds-utils';
import { jsx, Fragment } from 'react/jsx-runtime';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { Input } from '../Input/Input.js';

var _excluded = ["onChange", "style", "className"];
var SearchInput = styled(Input).withConfig({
  displayName: "Search__SearchInput",
  componentId: "sc-v8l23u-0"
})(["input{&[type='search']::-webkit-search-decoration,&[type='search']::-webkit-search-cancel-button,&[type='search']::-webkit-search-results-button,&[type='search']::-webkit-search-results-decoration{-webkit-appearance:none;}}"]);
var InsideButton = styled(Button).withConfig({
  displayName: "Search__InsideButton",
  componentId: "sc-v8l23u-1"
})(["height:24px;width:24px;"]);
var Search = /*#__PURE__*/forwardRef(function Search(_ref, ref) {
  var _onChange = _ref.onChange,
    style = _ref.style,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var _useState = useState(Boolean(rest.defaultValue)),
    _useState2 = _slicedToArray(_useState, 2),
    showClear = _useState2[0],
    setShowClear = _useState2[1];
  useEffect(function () {
    if (rest.disabled) {
      setShowClear(false);
    } else if (rest.value) {
      setShowClear(Boolean(rest.value));
    }
  }, [rest.value, rest.disabled]);
  var clearInputValue = function clearInputValue() {
    var input = inputRef.current;
    var clearedValue = '';
    setReactInputValue(input, clearedValue);
  };
  var handleOnChange = function handleOnChange(e) {
    setShowClear(Boolean(e.currentTarget.value));
  };
  var combinedRef = useMemo(function () {
    return mergeRefs(inputRef, ref);
  }, [inputRef, ref]);
  return /*#__PURE__*/jsx(InputWrapper, {
    role: "search",
    style: style,
    className: className,
    children: /*#__PURE__*/jsx(SearchInput, _objectSpread({
      onChange: function onChange(e) {
        handleOnChange(e);
        if (_onChange) {
          _onChange(e);
        }
      },
      ref: combinedRef,
      leftAdornmentsWidth: 24 + 8,
      leftAdornments: /*#__PURE__*/jsx(Icon, {
        data: search,
        "aria-hidden": true,
        size: 18
      }),
      rightAdornmentsWidth: 24 + 8,
      rightAdornments: /*#__PURE__*/jsx(Fragment, {
        children: showClear && /*#__PURE__*/jsx(InsideButton, {
          "aria-label": 'clear search',
          title: "clear",
          variant: "ghost_icon",
          onClick: function onClick(e) {
            e.stopPropagation();
            clearInputValue();
          },
          children: /*#__PURE__*/jsx(Icon, {
            data: close,
            size: 16
          })
        })
      })
    }, rest))
  });
});

export { Search };
